module.exports = __webpack_public_path__ + "static/img/exploit11.c7c6e423.png";